import Dialog from 'material-ui/Dialog';
import * as React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import Col from 'reactstrap/lib/Col';
import {IHistory} from '../../interfaces';
import {ModuleModel} from '../../model/ModuleModel';
import {UserModel} from '../../model/UserModel';
import {UserModuleModel} from '../../model/UserModulesModel';
import {addZero, userUniqueID} from '../../utils/generalUtils';
import {InputField} from '../reusableComponents/FormComponents/InputField';
import {Icon} from '../reusableComponents/Icon';
import {Loader} from '../reusableComponents/Loader/Loader';
import {IAPIModules} from '../Users/UserForm';
import './userModules.scss';
import {CustomFlatButton} from '../reusableComponents/CutomFlatButton';
import {PerfectScrollbar} from '../reusableComponents/PerfectScrollbar';
import {updateUserModule} from '../../services/userModuleService';
import * as _ from 'lodash';
import TextField from 'material-ui/TextField';
import {TextColor} from '../../constants/generals';

export interface IListItemProps {
    instance?: UserModuleModel;
    moduleInstances: ModuleModel[];
    index?: number;
    onClick?: Function;
    className?: string;
    history?: IHistory;
}

export interface IListItemState {
    isEditOpen: boolean;
    isInfoOpen: boolean;
    isLoading: boolean;
    selectedModules: {
        label: string;
        value: string;
        TrainingDuration: number | string;
        Completed: boolean;
        Category: string;
        UniqueId: string;
        DateCompleted: any;
        CompletedDate : any;
        Expired : string;
        ModuleId: string;
        ParentId: string;
    }[];
    selectOptions: any;
    defaultValues: any;
    editedModules: {
        label: string;
        value: string;
        TrainingDuration: number | string;
        Completed: boolean;
        Category: string;
        UniqueId: string;
        DateCompleted: any;
        CompletedDate:any;
        Expired : string;
        ModuleId: string;
        ParentId: string;
    }[];
    isTouched: boolean;
}

export class ListItemImpl extends React.Component<IListItemProps, IListItemState> {
    constructor(props: IListItemProps) {
        super(props);
        const selectOptions = this.getModules(this.props.moduleInstances).filter(({value: id1}) => !this.getDefaultModules(this.props.instance.props.Modules).some(({value: id2}) => id2 === id1));
        
        this.state = {
            isEditOpen: false,
            selectedModules: this.getDefaultModules(this.props.instance.props.Modules),
            editedModules: [],
            selectOptions: selectOptions,
            isLoading: false,
            isInfoOpen: false,
            isTouched: false,
            defaultValues: this.props.instance.props.Modules
        };
    }

    public componentWillReceiveProps(nextProps: IListItemProps, nextState) { 
        if (this.props.instance.props.Modules !== nextProps.instance.props.Modules && !this.state.isTouched &&
            (this.state.selectedModules.length >= 0)) {
            this.setState({
                selectedModules: this.getDefaultModules(nextProps.instance.props.Modules)
            });
        }
    }

    public getDefaultModules = (modules: IAPIModules[]) => {
        const moduleIDs = (modules || []).map((moduleData) => {
            return {label: moduleData.ModuleName, value: moduleData.ModuleId, Completed: moduleData.Completed, TrainingDuration: moduleData.TrainingDuration, UniqueId: moduleData.UniqueId, DateCompleted: moduleData.DateCompleted, Expired: moduleData.Expired, ModuleId: moduleData.ModuleId};
        });
        return moduleIDs as any;
    }

    public getModules = (instances) => {
        const options = [];
        instances.forEach(instance => {
            options.push({
                label: instance.props.Name,
                value: instance.props.ModuleID
            });
        });
        return options;
    }

    public updateModule = async () => { 
        const {instance: {props: {id, Name}}} = this.props;
        const selectedModules = this.state.editedModules;
        const notCompletedData = selectedModules.filter((modules, index) => {
            return modules.Completed !== true;
        });
        const completedModules = selectedModules.filter((modules, index) => {
            return modules.Completed === true;
        });
        const data = notCompletedData.map((moduleData) => {
            return {
                'UniqueId': moduleData.UniqueId || null,
                'ModulesName': moduleData.label,
                'ModulesId': moduleData.value,
                'Category': moduleData.Category,
                'Duration': moduleData.TrainingDuration,
                'DateCompleted': moduleData.DateCompleted,
                'Expired': moduleData.Expired
            };
        });
        const completedData = completedModules.map((moduleData) => moduleData.value);
        this.setState({
            isLoading: true,
        });
        
        await updateUserModule(id, name, data, completedData, this);

        this.setState({
            isLoading: false,
            // isEditOpen: false,
            // editedModules: []
        });
    }
    getTrainingDuration = (modulesList,value) => {
        let modules = [];
        let selectedModules = [];
        // modules = this.state.editedModules;
        let modulesLen = modulesList.length;
        let sortedListItems = [];

        this.props.moduleInstances.forEach((module) => {
            if (module.props.ModuleID == value.value ) {

            
            const foundedModule = _.find(modulesList, {value: module.props.ModuleID});
            modules.push({
                        label: module.props.Name,
                        value: module.props.ModuleID,
                        Completed: module.props.Completed,
                        // UniqueId: module.props.UniqueId == undefined ? '' : module.props.id,
                        UniqueId: '',
                        // TrainingDuration: foundedModule.TrainingDuration ? foundedModule.TrainingDuration : module.props.TrainingDuration,
                        TrainingDuration: module.props.TrainingDuration ? module.props.TrainingDuration : '',
                        DateCompleted: module.props.DateCompleted == undefined ? '' : module.props.DateCompleted,
                        Expired: module.props.Expired ? module.props.Expired : ''
                    });
            }
        });
        // modules.push(this.state.editedModules);
        this.state.editedModules.forEach((module) => {
            modules.push({
                        label: module.label,
                        value: module.value,
                        Completed: module.Completed,
                        UniqueId: module.UniqueId,
                        // TrainingDuration: foundedModule.TrainingDuration ? foundedModule.TrainingDuration : module.props.TrainingDuration,
                        TrainingDuration:module.TrainingDuration ? module.TrainingDuration : '',
                        DateCompleted: module.DateCompleted ? module.DateCompleted : '',
                        Expired: module.Expired ? module.Expired : ''
                    });
        });
        return modules;
    }


    public handleModuleSelect = (value) => {
        const selected = JSON.parse(JSON.stringify(this.state.editedModules));
        selected.push(value);
        const selectOptions = this.getModules(this.props.moduleInstances).filter(({value: id1}) => !selected.some(({value: id2}) => id2 === id1));
        this.setState({
            isTouched: true,
            editedModules: this.getTrainingDuration(JSON.parse(JSON.stringify(selected)),value),
            selectOptions,
            isLoading: true
        }, () => {
            this.setState({isLoading: false});
        });
    }

    public handleModuleRemove = async (value) => {
        const selected = this.state.editedModules.filter((moduleData) => moduleData.value !== value);
        const sel =selected;
        const selectOptions = this.getModules(this.props.moduleInstances).filter(({value: id1}) => !selected.some(({value: id2}) => id2 === id1));
        await this.setState({
            selectOptions,
            editedModules: selected,
            selectedModules: sel
        });
    }

    public renderEditUserModuleDialog = () => {
        const {instance, moduleInstances} = this.props;
        const pndIcon = <Icon icon="exclamation-triangle" />;
        const compIcon = <Icon icon="check-circle" />;
        const questIcon = <Icon icon="clock" />;

        const actions = [
            <CustomFlatButton
                label="Cancel"
                color={'white'}
                primary={true}
                onClick={() => this.setState({isEditOpen: false, editedModules: []})}
            />,
            <CustomFlatButton
                label="Update Modules"
                color={'white'}
                primary={true}
                onClick={this.updateModule}
            />
        ];
        return <Dialog
            bodyStyle={dialogBodyStyle}
            titleStyle={dialogTitleStyle}
            title={`Edit ${instance.props.Name}'s Modules`}
            actionsContainerStyle={actionsContainerStyle}
            actions={actions}
            modal={true}
            onRequestClose={() => this.setState({isEditOpen: false, editedModules: []})}
            open={this.state.isEditOpen}
            className='UserModuleUpdateList'
        >
            {this.state.isLoading && <Loader type="submission"/>}
            <InputField
                id="trainingModules"
                hintText=""
                label="Training Modules:"
                type="select"
                color={'white'}
                noChips={true}
                multi
                onChange={this.handleModuleSelect}
                model=""
                // defaultValue={instance && this.getDefaultModules(instance.props.Modules as any)}
                // defaultValue={instance && this.getDefaultModules(this.state.selectedModules as any)}
                menuItems={this.state.selectOptions}
            />
            {/* <PerfectScrollbar className="list-page-container"> */}
            <div className={'training-list'}>
                <table className={'assigned-module-list-table'}>
                {this.state.editedModules.length > 0 ?
                <thead className='table-head'>
                <tr>
                    <th>Module Name</th>
                    <th>Duration</th>
                    <th>Status</th>
                    <th>Completed On</th>
                    <th>Action</th>
                </tr>
                </thead>
                :''}
                {/* <PerfectScrollbar className="list-page-container">
                    <div key={'header'} className="module-item">
                        <div className="module-name grid-title">Module</div>
                        <div className="module-name grid-title">
                            Status
                        </div>
                        <div className="module-name grid-title">Duration</div>
                        <div className="module-name grid-title">Due Date</div>
                        <div className="module-name grid-title">Completed Date</div>
                    </div> */}
                    <tbody className={'table-body'}>
                    {this.state.editedModules.map((module: any, i) => {
                        return <tr key={'updateModule' + i}>
                            <td className={'name-header'} key={module.label + i}>{module.label}</td>
                            <td className={'duration-header'} key={module.TrainingDuration+'/'+module.label}>
                                <TextField
                                    id={"link"+i}
                                    name={"link"+i}
                                    // key={"link"+i}
                                    min={1}
                                    type="number"
                                    underlineStyle={style}
                                    defaultValue={module.TrainingDuration as string}
                                    disabled={module.Completed || (module.UniqueId && module.UniqueId.length > 0)}
                                    underlineFocusStyle={style}
                                    inputStyle={inputFontStyle}
                                    floatingLabelStyle={style}
                                    className="mui-input"
                                    onBlur={(e) => {
                                        // @ts-ignore
                                        const value = e.target.value;
                                        const selectedValues = this.state.editedModules;
                                        selectedValues[i].TrainingDuration = value;
                                        this.setState({
                                            editedModules: selectedValues
                                        });
                                    }
                                    }
                                    rows={1}
                                />
                            </td>
                            {/* <td className={'duration-header'} key={module.TrainingDuration + i}>{module.TrainingDuration}</td> */}
                            <td className={'status-header'} key={module.Expired + i}>
                                {module.Expired ?  pndIcon : module.Completed ? compIcon : questIcon}
                                {module.Expired ?  ' Overdue' : module.Completed ? ' Completed' : ' Pending'}
                            </td>
                            <td className={'date-header'} key={module.DateCompleted}>{module.DateCompleted}</td>
                            <td className={'action-header'}>{!module.Completed && <span onClick={() => this.handleModuleRemove(module.value)} className={'action-cursor fa fa-trash'}/>}</td>
                        </tr>;
                    })
                    }
                    </tbody>
                </table>
            </div>
            {/* </PerfectScrollbar> */}
        </Dialog>;
    }

    public renderUserModulesInfo = () => {
        const {instance} = this.props;
        const pndIcon = <Icon icon="exclamation-triangle" />;
        const questIcon = <Icon icon="clock" />;
        const compIcon = <Icon icon="check-circle" />;

        return <Dialog
            bodyStyle={dialogBodyStyle}
            titleStyle={dialogTitleStyle}
            title={`${instance.props.Name}'s Modules`}
            modal={false}
            onRequestClose={() => this.setState({isInfoOpen: false})}
            open={this.state.isInfoOpen}
        >
            <div className="user-module-details">
                <PerfectScrollbar className="list-page-container">
                    <div key={'header'} className="module-item">
                        <div className="module-name grid-title">Module</div>
                        <div className="module-name grid-title">
                            Status
                        </div>
                        <div className="module-name grid-title">Duration</div>
                        <div className="module-name grid-title">Due Date</div>
                        <div className="module-name grid-title">Completed Date</div>
                    </div>
                    {instance.props.Modules.map((moduleData, index) => {
                        return <div key={index} className="module-item">
                            <div key={moduleData.ModuleName + index} className="module-name">{moduleData.ModuleName}</div>
                            <div key={moduleData.Completed + index} className="status">
                                {/* {moduleData.Completed > 0 ?
                                    <Icon icon="check-circle"/> : <Icon icon="exclamation-triangle"/>}
                                &nbsp;
                                {moduleData.Completed > 0 ?
                                    'Completed' : 'Pending'} */}

                                {moduleData.Expired ?  pndIcon : moduleData.Completed > 0 ? compIcon : questIcon}
                                {moduleData.Expired ?  ' Overdue' : moduleData.Completed > 0 ? ' Completed' : ' Pending'}    
                            
                            </div>
                            <div key={moduleData.TrainingDuration + index} className="module-name">{moduleData.TrainingDuration + ' Days'}</div>
                            <div key={moduleData.DueDate + index} className="module-name">{moduleData.DueDate}</div>
                            <div key={moduleData.DateCompleted + index} className="module-name">{moduleData.DateCompleted}</div>
                        </div>;
                    })}
                    <Icon onClick={() => this.setState({isInfoOpen: false, isEditOpen: true, editedModules: JSON.parse(JSON.stringify(this.state.selectedModules))})} icon="pencil-alt"/>
                </PerfectScrollbar>
            </div>
        </Dialog>;
    }

    public render() {
        const {Name, Modules, modulesCount, Id} = this.props.instance.props;
        return <div className={`list-item user-module-list-item`}>
            {this.renderEditUserModuleDialog()}
            {this.renderUserModulesInfo()}
            <Col onClick={() => this.setState({isInfoOpen: true})} className="serial-no center" sm={1}>
                {Id ? addZero(Id) : ''}
            </Col>
            <Col onClick={() => this.setState({isInfoOpen: true})} className="name" sm={5}>{Name}</Col>
            <Col onClick={() => this.setState({isInfoOpen: true})}
                 className="name modules" sm={2}>{modulesCount}</Col>
            <Col
                key="pencil"
                className="update"
                onClick={() => this.setState({isEditOpen: true, editedModules: JSON.parse(JSON.stringify(this.state.selectedModules))})}
                sm={4}>
                <Icon icon="pencil-alt"/>
                &nbsp;
                Update Modules
            </Col>
        </div>;
    }
}

export function mapStateToProps(state) {
    return {
        userInstance: UserModel.get(userUniqueID(state)),
        moduleInstances: ModuleModel.list()
    };
}

export const ListItem = withRouter(connect<{}, {}, IListItemProps>(mapStateToProps)(ListItemImpl) as any);

const dialogBodyStyle: React.CSSProperties = {
    backgroundColor: '#003152',
    color: 'white',
    // width: '80%'
};

const actionsContainerStyle: React.CSSProperties = {
    backgroundColor: '#003152',
    // width: '80%'
};

const dialogTitleStyle: React.CSSProperties = {
    backgroundColor: '#a4bf43',
    color: '#fdfcfc',
    // width: '80%'
};

const style: React.CSSProperties = {
    color: TextColor,
    borderColor: TextColor
};

const inputFontStyle: React.CSSProperties = {
    color: 'white'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/UserModules/ListItem.tsx